import { features } from '@/mocks/home';

export default function Features() {
  return (
    <section id="features" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10">
          为什么选择天堂影视
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {features.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-6 md:p-8 text-center group hover:bg-primary-50/30 transition-colors duration-300">
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center mx-auto mb-5 rounded-2xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${item.icon} text-2xl md:text-3xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}